import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  ConfigModel,
  selectConfig,
  getConfig,
} from "../store/features/configSlice";
import { useAppDispatch } from "../store/hooks";
import { RootState } from "../store/store";
import { hotjar } from "react-hotjar";

export default function ConfigLoader(props: { children?: React.ReactNode }) {
  const state: ConfigModel = useSelector(selectConfig);

  const configStatus = useSelector((state: RootState) => state.config.status);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (configStatus === "idle") {
      dispatch(getConfig());
    }

    if (
      configStatus === "succeeded" &&
      state.hotjarid != null &&
      state.hotjarsnippetversion != null
    ) {
      hotjar.initialize(state.hotjarid, state.hotjarsnippetversion);
    }
  }, [state, configStatus, dispatch]);

  return <>{props.children}</>;
}
